import CONFIG from './config';
import React, { Component } from 'react';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';

import Icon from './Icons';
import { CategoryIcon } from './Category';

export class MetaDataBar extends Component {
	constructor() {
		super();
		this.state = {
			show_profile: false
		}
		this.handleClick = this.handleClick.bind(this)
	}
	handleClick() {
		this.setState({show_profile: !this.state.show_profile})
	}
	render() {
		const { authorimage, author, created, category, className } = this.props;
		const { show_profile } = this.state;

		var profile;
		if (show_profile)
			profile = <Profile author={author} />

		return (
			<div className={`post-meta ${className}`}>
				<div className='group'>

					<div
						className='post-author-picture'
						style={{
							backgroundImage: `url(${ authorimage })`
						}}>
						{ profile }
					</div>
					<div className='post-author' >
						{ author }
					</div>
					<div className='post-date'>
						<Icon className="icon-xxs" icon="calendar" />
						<Moment unix>{created}</Moment>
					</div>
				</div>
				<div className='group category-link' >
					<Link to={`/search/category/${category}`}>
						<CategoryIcon category={category} />
						<div className='category-title'>
							{ category }
						</div>
					</Link>
				</div>
			</div>
		)
	}
}

export class TagBar extends Component {
	constructor() {
		super();
		this.state = {
			showtagbar_list: true
		}
		this.handleClick = this.handleClick.bind(this);
	}
	handleClick() {
		this.setState({showtagbar_list: !this.state.showtagbar_list});
	}
	render() {
		const { className, tags } = this.props;
		const { showtagbar_list } = this.state;

		const tags_list = tags.map(tag => <Tag tag={tag} />)

		var tagbar_list_style = {
			display: "none"
		};
		if (showtagbar_list) {
			tagbar_list_style = {
				display: "flex"
			}
		}

		const style = {
			display: "flex",
			justifyContent: "center"
		}
		return (
			<div
				className={`tagbar ${className | ''}`}
				style={style}

			>
				<Icon
					icon="tag"
					onClick={this.handleClick}
					style={{cursor: "pointer"}}
				/>
				<div className='tagbar-list' style={tagbar_list_style}>
					{tags_list}
				</div>
			</div>
		)
	}
}

export class Tag extends Component {
	render() {
		const { tag } = this.props;

		return (
			<div className="tag">
				<Link to={`/search/tags/${tag}`}>
					{tag}
				</Link>
			</div>
		)
	}
}

export class Profile extends Component {
	render() {
		return
	}
}



// WEBPACK FOOTER //
// ./src/Utils.js